import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { PasswordService } from './../../services/password.service';
import { SpinnerService } from './../spinner/spinner.service';
import { CardValidationService } from 'src/app/services/card-validation.service';

@Component({
  selector: 'gca-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss']
})

export class CreatePasswordComponent implements OnInit, OnDestroy {
  errorMessage: string;
  form: FormGroup;
  memberId: string;
  resetToken: string;
  sub: Subscription;
  submitted = false;
  isCardActivationError: boolean;


  constructor(
    private cardValidationService: CardValidationService,
    private fb: FormBuilder,
    // private googleAnalyticsService: GoogleAnalyticsService,
    private passwordService: PasswordService,
    private route: ActivatedRoute,
    private router: Router,
    private spinnerService: SpinnerService,
  ) {
    this.buildForm();
  }

  ngOnInit() {
    this.sub = this.route.queryParams.pipe(
      map(params => {
        if (params.reset && params.custid) {
          this.cardValidationService.memberId = params.custid;
          this.resetToken = params.reset;
          return;
        }
      })
    ).subscribe();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.valid) {
      this.spinnerService.showSpinner({text: 'Creating password…'});
      this.passwordService.sendNewPassword(this.cardValidationService.memberId, this.resetToken, this.form.value.password)
        .subscribe(res => {
          this.spinnerService.hideSpinner();
          this.activateGiftCard();
        }, error => {
          this.errorMessage = error.error_description;
          this.spinnerService.hideSpinner();
        });
    }
  }

  showError(controlName: string, formGroupName?: string): boolean {
    if (formGroupName) {
      return (<FormGroup>this.form.controls[formGroupName]).controls[controlName].invalid &&
        (<FormGroup>this.form.controls[formGroupName]).controls[controlName].dirty ||
        (<FormGroup>this.form.controls[formGroupName]).controls[controlName].invalid && this.submitted;
    } else {
      return this.form.controls[controlName].invalid &&
        this.form.controls[controlName].dirty ||
        this.form.controls[controlName].invalid && this.submitted;
    }
  }

  private activateGiftCard(): void {
    this.spinnerService.showSpinner({text: 'Card activation being processed…'});
    this.cardValidationService.activateCard().subscribe(res => {
      this.spinnerService.hideSpinner();
      if (res.Result === 0) {
        this.errorMessage = res.ResultMessage;
        this.isCardActivationError = true;
      } else {
        // this.googleAnalyticsService.gtagReportEvent('Activation', 'GC Activation', 'Activate');
        this.router.navigate(['/thanks']);
      }
    }, error => {

      this.spinnerService.hideSpinner();
      this.errorMessage = error.Message ? error.Message : 'Something went wrong...';
    });
  }

  private buildForm() {
    this.form = this.fb.group(
      {
        password: ['', [
          Validators.required,
          Validators.maxLength(11),
          Validators.minLength(6),
          Validators.pattern(/^[a-zA-Z0-9]*$/)
        ]],
        confirmPassword: ['', Validators.required],
      },
      { validator: this.equalPasswords('password', 'confirmPassword') }
    );
  }

  private equalPasswords(passwordName: string, confirmPasswordName: string): Function {
    return (group: FormGroup): {[key: string]: any} => {
      const password = group.controls[passwordName];
      const confirmPassword = group.controls[confirmPasswordName];

      if (password.value !== confirmPassword.value) {
        return {
          equalPasswords: true
        };
      }
    };
  }
}
